<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>淘客</el-breadcrumb-item>
          <el-breadcrumb-item>淘宝榜单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true">
          <el-row>
            <el-button type="primary" size="small" @click="query(27446)">大额券</el-button>
            <el-button type="default" size="small" @click="query(27448)">女装</el-button>
            <el-button type="default" size="small" @click="query(27451)">食品</el-button>
            <el-button type="default" size="small" @click="query(27451)">美妆个护</el-button>
            <el-button type="default" size="small" @click="query(27798)">家居家装</el-button>
            <el-button type="default" size="small" @click="query(27454)">母婴</el-button>
          </el-row >
          <el-row style="margin-top:7px">
            <el-button type="primary" size="small" @click="query(13366)">高佣榜</el-button>
            <el-button type="default" size="small" @click="query(13367)">女装</el-button>
            <el-button type="default" size="small" @click="query(13368)">家居家装</el-button>
            <el-button type="default" size="small" @click="query(13369)">数码家电</el-button>
            <el-button type="default" size="small" @click="query(13370)">鞋包配饰</el-button>
            <el-button type="default" size="small" @click="query(13371)">美妆个护</el-button>
            <el-button type="default" size="small" @click="query(13372)">男装</el-button>
            <el-button type="default" size="small" @click="query(13373)">内衣</el-button>
            <el-button type="default" size="small" @click="query(13374)">母婴</el-button>
            <el-button type="default" size="small" @click="query(13375)">食品</el-button>
            <el-button type="default" size="small" @click="query(13376)">运动户外</el-button>
            <el-button type="default" size="small" @click="query(78393)">宠物</el-button>
          </el-row>
          <el-row style="margin-top:7px">
            <el-button type="primary" size="small" @click="query(3786)">品牌券</el-button>
            <el-button type="default" size="small" @click="query(86623)">女装</el-button>
            <el-button type="default" size="small" @click="query(86622)">家居家装</el-button>
            <el-button type="default" size="small" @click="query(86621)">数码家电</el-button>
            <el-button type="default" size="small" @click="query(86620)">鞋包配饰</el-button>
            <el-button type="default" size="small" @click="query(86619)">美妆个护</el-button>
            <el-button type="default" size="small" @click="query(86618)">男装</el-button>
            <el-button type="default" size="small" @click="query(86617)">内衣</el-button>
            <el-button type="default" size="small" @click="query(86616)">母婴</el-button>
            <el-button type="default" size="small" @click="query(86614)">食品</el-button>
            <el-button type="default" size="small" @click="query(86615)">运动户外</el-button>
          </el-row>
          <el-row style="margin-top:7px">
            <el-button type="primary" size="small" @click="query(30443)">本地生活</el-button>
            <el-button type="default" size="small" @click="query(19812)">淘票票</el-button>
            <el-button type="default" size="small" @click="query(25378)">大麦网</el-button>
            <el-button type="default" size="small" @click="query(28636)">优酷会员</el-button>
            <el-button type="default" size="small" @click="query(29015)">有声内容</el-button>
            <el-button type="default" size="small" @click="query(25888)">阿里健康</el-button>
            <el-button type="default" size="small" @click="query(19811)">飞猪</el-button>
            <el-button type="default" size="small" @click="query(28888)">口碑</el-button>
            <el-button type="default" size="small" @click="query(19814)">家政服务</el-button>
          </el-row> 
          
        </el-form>
        <el-table :data="rows" style="width: 100%">
          <el-table-column  prop="itemBasicInfo.title"  :show-overflow-tooltip="true" label="标题"> </el-table-column>
          <el-table-column  prop="itemBasicInfo.pictUrl" label="图标" width="80" align="center">
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.itemBasicInfo.pictUrl"
                placement="right"
                trigger="hover"
              >
                <div>
                  <img
                    :src="scope.row.itemBasicInfo.pictUrl"
                    width="400"
                    
                  >
                </div>  
                <img
                  slot="reference"
                  :src="scope.row.itemBasicInfo.pictUrl"
                  width="20"
                  height="20"
                >
              </el-popover> 
              <p v-else>
                --
              </p>
            </template>         
          </el-table-column> 
          <el-table-column  prop="itemBasicInfo.annualVol" label="年销量"> </el-table-column>
          <el-table-column  prop="pricePromotionInfo.zkFinalPrice" label="原价"> </el-table-column>        
          <el-table-column  prop="pricePromotionInfo.finalPromotionPrice"  label="券后价" ></el-table-column>
          <el-table-column  prop="publishInfo.incomeRate" :formatter="PercenPtageFormat" label="最高佣金"></el-table-column>
          <el-table-column  prop="itemBasicInfo.brandName" :show-overflow-tooltip="true" label="品牌名称"> </el-table-column>
          <el-table-column  fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click.native.prevent="editChainStore(scope.row)" type="text" size="small">
                淘口令
              </el-button>
            </template>
          </el-table-column>
          
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        rows:[],
        queryParam:{
          name:'',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          materialId:27446,
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      query:function(materialId){
        this.queryParam.materialId = materialId
        this.queryParam.pageIndex = 1
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/taoBao/GoodsList',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.rows = resp.data.rows
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },
      handleSizeChange(val) {
        this.queryParam.pagesize =  val
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val
        this.GetData()
      },      
      PercenPtageFormat(row, column, cellValue, index){
        let value = cellValue
	      return  value +'%'
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>